import { CycleUtils } from '@wix/package-picker-shared';
import { useCurrentModule } from '../components/ModuleProvider';
const getMaximalMonthlyPrice = pricingDetails => {
  var _monthly$finalPrice;
  const monthly = pricingDetails == null ? void 0 : pricingDetails.find(d => d.cycle && CycleUtils.isMonthly(d.cycle));
  return monthly == null || (_monthly$finalPrice = monthly.finalPrice) == null ? void 0 : _monthly$finalPrice.monthlyTotal;
};

/**
 * Sale path: show catalog full price if it differs from the final price.
 */
const getSaleStrikeout = (monthlyFullPrice, monthlyFinalPrice) => {
  if (monthlyFullPrice != null && monthlyFullPrice.formattedAmount && monthlyFullPrice.formattedAmount !== (monthlyFinalPrice == null ? void 0 : monthlyFinalPrice.formattedAmount)) {
    return monthlyFullPrice.formattedAmount;
  }
  return undefined;
};

/**
 * Non-sale path: show the monthly billing plan's rate as strikeout
 * when it's higher than this cycle's effective monthly price.
 */
const getNonSaleStrikeout = (monthlyFinalPrice, pricingDetails) => {
  const maximalMonthlyPrice = getMaximalMonthlyPrice(pricingDetails);
  if (maximalMonthlyPrice != null && maximalMonthlyPrice.formattedAmount && Number(maximalMonthlyPrice.amount) > Number(monthlyFinalPrice == null ? void 0 : monthlyFinalPrice.amount)) {
    return maximalMonthlyPrice.formattedAmount;
  }
  return undefined;
};

/**
 * Strikeout price for a cycle-selector row.
 * Returns the formatted amount to show crossed out next to the main price,
 * or `undefined` if no strikeout applies.
 */
export const useCycleSelectorStrikeout = (productId, cycleId) => {
  const module = useCurrentModule();
  const enabled = Boolean(productId && cycleId);
  const {
    data: cyclePricingData
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchCyclePricing({
    productId: productId ?? '',
    cycleId: cycleId
  }, enabled);
  const {
    data: product
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchProduct({
    productId: productId ?? ''
  }, enabled);
  const {
    data: offeringDiscount
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isNonSaleStrikeoutEnabled = experiments.isEnabled('specs.premium.stikeoutPriceNonSale');
  const {
    cyclePricing
  } = cyclePricingData ?? {};
  const {
    monthlyFullPrice,
    monthlyFinalPrice
  } = cyclePricing ?? {};
  if (offeringDiscount != null && offeringDiscount.hasSale) {
    if (product != null && product.hasSale) {
      return getSaleStrikeout(monthlyFullPrice, monthlyFinalPrice);
    }
    return undefined;
  } else if (isNonSaleStrikeoutEnabled) {
    return getNonSaleStrikeout(monthlyFinalPrice, product == null ? void 0 : product.pricingDetails);
  }
  return undefined;
};
//# sourceMappingURL=useCycleSelectorStrikeout.js.map